<template>
  <div class="stats-sidebar">
    <div class="stats-header">
      <h3>Your Stats</h3>
      <v-btn
        icon="mdi-refresh"
        size="small"
        variant="text"
        :loading="loading"
        @click="refreshStats"
        title="Refresh stats"
      ></v-btn>
    </div>
    
    <div class="stats-cards">
      <div class="stat-card">
        <div class="stat-icon">{{ workspaceEmoji.emojiSymbol }}</div>
        <div class="stat-content">
          <h4>Total Received</h4>
          <div class="stat-value">{{ stats.points }}</div>
        </div>
      </div>
      
      <div class="stat-card">
        <div class="stat-icon">📊</div>
        <div class="stat-content">
          <h4>Total Given</h4>
          <div class="stat-value">{{ stats.pointsGiven || '-' }}</div>
        </div>
      </div>
      
      <div class="stat-card">
        <div class="stat-icon">🎁</div>
        <div class="stat-content">
          <h4>Redeemable</h4>
          <div class="stat-value">{{ stats.redeemablePoints }}</div>
        </div>
      </div>
      
      <div class="stat-card">
        <div class="stat-icon">⭐</div>
        <div class="stat-content">
          <h4>Rank</h4>
          <div class="stat-value">{{ stats.rank || '-' }}</div>
        </div>
      </div>
    </div>
    
    <div v-if="error" class="stats-error">
      <v-alert type="error" variant="tonal" density="compact">
        {{ error }}
      </v-alert>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStatsStore } from '../stores/statsStore'
import { useWorkspaceStore } from '../stores/workspaceStore'

const { stats, loading, error, fetchStats, refreshStats } = useStatsStore()
const { getWorkspaceEmoji } = useWorkspaceStore()
const workspaceEmoji = getWorkspaceEmoji()

// Expose refresh function for parent components
defineExpose({
  refresh: refreshStats
})
</script>

<style scoped>
.stats-sidebar {
  width: 300px;
  background: white;
  border-left: 1px solid #e1e5e9;
  height: 100vh;
  position: fixed;
  right: 0;
  top: 0;
  padding: 2rem 1.5rem;
  padding-top: 6rem; /* Account for fixed navigation */
  overflow-y: auto;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  z-index: 100;
}

.stats-header {
  margin-bottom: 2rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.stats-header h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
}

.stats-cards {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
}

.stat-card {
  background: #f8fafc;
  border-radius: 12px;
  padding: 1.25rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  border: 1px solid #e1e5e9;
  transition: all 0.2s ease;
}

.stat-card:hover {
  background: #f1f5f9;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stat-icon {
  font-size: 1.5rem;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.stat-content {
  flex: 1;
}

.stat-content h4 {
  font-size: 0.875rem;
  font-weight: 600;
  color: #666;
  margin: 0 0 0.25rem 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
}

.stats-error {
  margin-bottom: 1rem;
}

@media (max-width: 1024px) {
  .stats-sidebar {
    display: none;
  }
}
</style> 